<mat-card class="messages-card">
  <mat-card-header>
    <mat-card-title>Messages</mat-card-title>
  </mat-card-header>

  <mat-card-content class="messages-content">
    <div class="messages-container" #messagesContainer>
      @if (displayMessages().length === 0) {
        <div class="no-messages">
          <mat-icon>chat_bubble_outline</mat-icon>
          <span>No messages yet</span>
          <span class="hint">Start a conversation about this referral</span>
        </div>
      } @else {
        @for (group of groupedMessages(); track group.date) {
          <div class="date-group">
            <div class="date-header">
              <span>{{ group.date }}</span>
            </div>
            @for (msg of group.messages; track msg.id) {
              <div class="message-row" [class.sent]="msg.isSent" [class.received]="!msg.isSent">
                <div class="message-bubble">
                  @if (!msg.isSent) {
                    <div class="sender-name">{{ msg.senderName }}</div>
                  }
                  <div class="message-text">{{ msg.message }}</div>
                  <div class="message-meta">
                    <span class="message-time">{{ formatTime(msg.createdDate) }}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      }
    </div>
  </mat-card-content>

  <!-- Message Input -->
  <div class="message-input-container">
    <mat-form-field appearance="outline" class="message-input">
      <input matInput
             placeholder="Type a message..."
             [value]="newMessage()"
             (input)="onMessageInput($event)"
             (keydown)="onKeydown($event)"
             [disabled]="isSending() || disabled()">
    </mat-form-field>
    <button mat-icon-button
            color="primary"
            (click)="sendMessage()"
            [disabled]="!newMessage().trim() || isSending() || disabled()">
      @if (isSending()) {
        <mat-spinner diameter="24"></mat-spinner>
      } @else {
        <mat-icon>send</mat-icon>
      }
    </button>
  </div>
</mat-card>
